import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import {
  VStack,
  useTheme,
  Button,
  Text,
  PartialPage,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { BarcodeScannerRootParamList } from "../../../../../../types";
import { ScannedBarcodeFormatBanner } from "../../../../components";
import { BarcodeScannerScreenContext } from "../../../context";
import React from "react";

export const ScanAgainScreen = () => {
  const {
    params: { barcode, format },
  } = useRoute<RouteProp<BarcodeScannerRootParamList, "ScanAgainScreen">>();

  const { spacings } = useTheme();
  const { goBack } = useNavigation<any>();

  const maybeContext = React.useContext(BarcodeScannerScreenContext);

  const footer = (
    <VStack spacing={spacings.s2}>
      <Button
        isAction
        style={{
          display: "flex",
        }}
        label="Scan again"
        onPress={goBack}
      />
      {maybeContext?.onNoProductSecondaryAction && (
        <Button
          isAction
          style={{
            display: "flex",
          }}
          label={maybeContext.onNoProductSecondaryAction.label}
          onPress={() =>
            maybeContext.onNoProductSecondaryAction.onPress(barcode)
          }
        />
      )}
    </VStack>
  );

  return (
    <PartialPage
      scrollable={false}
      size="compact"
      onClose={goBack}
      contentContainerStyle={{ flex: 1 }}
      animatedViewStyles={{
        maxHeight: "80%",
      }}
    >
      <Page
        footerStyles={{ padding: 0, borderTopWidth: 0 }}
        scrollable
        padding={0}
        cover
        footer={footer}
      >
        <View flex>
          <VStack>
            {!!format && <ScannedBarcodeFormatBanner format={format} />}
            <View>
              <Text
                variant="heading"
                fontWeight="medium"
                numberOfLines={5}
                ellipsizeMode="head"
              >
                {`No product found. Is the barcode '${barcode}' correct?`}
              </Text>
            </View>
          </VStack>
        </View>
      </Page>
    </PartialPage>
  );
};
